export default {
    name: 'AccountBeneficiaryDetails',
    /**
     * @override
     */
    data() {
        return {
            modifiedAccountBeneficiary: {},
            submitted: false,
            productOptions: [],
            productSelected: null,
            operations: []
        };
    },
    props: {
        accountBeneficiary: {
            type: Object,
            required: true
        },
        creation: {
            type: Boolean,
            required: false,
            default: false
        },
        edit: {
            type: Boolean,
            required: false,
            default: false
        },
        uuid_account: {
            type: String,
            required: false
        }

    },
    /**
     * @override
     */
    created() {
        this.modifiedAccountBeneficiary = Object.assign({}, this.accountBeneficiary);
        this.checkOperations();
        this.getProductOptions();
    },
    methods: {
        /**
         * Función genérica para guardar los elementos editados
         * @param {*} field Campo editado
         * @param {*} val Valor
         */
        setValueEdited(field, val) {
            if (field === 'key_product') {
                val = val.key_name;
            }
            this.modifiedAccountBeneficiary[field] = val;
        },
        /**
         * Invierte el valor de editAccountBeneficiary
         */
        toggleEdit() {
            this.editAccountBeneficiary = !this.editAccountBeneficiary;
        },
        /**
         * Emite el evento hideForm
         */
        handleCancel() {
            this.$emit('hideForm', true);
        },
        /**
         * Emite el evento submit
         */
        handleSubmit() {
            this.submitted = true;
            this.$emit('submit', this.modifiedAccountBeneficiary);
            this.$emit('hideForm', true);
        },
        /**
         * Obtiene los productos disponibles añadir un beneficiario
         */
        getProductOptions() {
            this.$productsService.getProducts('', {}).then(res => {
                this.productOptions = res.data.products.filter(product => {
                    return this.operations.includes(product.key_name);
                });
                if (this.accountBeneficiary['key_product']) {
                    this.productOptions.forEach(product => {
                        if (product.key_name === this.accountBeneficiary['key_product']) {
                            this.productSelected = product;
                        }
                    });
                }
            });
        },
        /**
         * Si se ha creado al menos una operacion de aportacion, se permitirá crear beneficiarios
         */
        checkOperations() {
            this.$accountsService.getAccountOperations(this.uuid_account).then(res => {
                const operations = res.data.related_operations;
                operations.forEach(operation => {
                    if (operation.key_product === 'INNOCAPITAL_MIXTO_GLOBAL' || operation.key_product === 'INNOCAPITAL_GLOBAL') {
                        this.operations.push(operation.key_product);
                    }
                });
            });
        }
    }
};
